import { render, staticRenderFns } from "./Sponsors.vue?vue&type=template&id=46fd5c99&scoped=true"
var script = {}
import style0 from "./Sponsors.vue?vue&type=style&index=0&id=46fd5c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd5c99",
  null
  
)

export default component.exports